<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<b-row>
					<b-col md="8">
						<h2>{{ this.$t('design.mediaPresentation') }}</h2>
					</b-col>

					<b-col md="4" class="text-md-right">
						<b-button @click="updateSettings()" variant="primary">{{ this.$t('global.saveChanges') }}</b-button>
					</b-col>
				</b-row>
				<hr>

				<!-- files -->
				<FilesRelated
					:file-keys="[
							{label: this.$t('design.headerLogo'), keyName: 'headerLogo'},
							{label: this.$t('design.footerLogo'), keyName: 'footerLogo'},
							{label: this.$t('design.homeBanner'), keyName: 'homeBanner'},
						]"
				/>
				<!-- /files -->

				<hr>
				<!-- files -->
				<b-row>
					<b-col lg="8">
						<h4>{{ this.$t('design.company') }}</h4>
						<b-row>
							<b-col lg="12" class="mb-2">
								<b-form-group
									:description="this.$t('design.publicNameDesc')"
									:label="this.$t('design.publicName')"
									label-for="publicName"
								>
									<b-form-input id="publicName" class="color-input" type="text" v-model="settings.publicName"/>
								</b-form-group>
							</b-col>
						</b-row>

						<hr>

						<h4>{{ this.$t('design.colors') }}</h4>
						<b-row>
							<b-col class="mb-3" lg="6">
								<b-form-group
									:description="this.$t('design.primaryColorDesc')"
									:label="this.$t('design.primaryColor')"
									label-for="primaryColor"
								>
									<b-form-input id="primaryColor" class="color-input" type="color" v-model="settings.primaryColor"/>
								</b-form-group>
							</b-col>
							<b-col class="mb-3" lg="6">
								<b-form-group
									:description="this.$t('design.btnBackgroundColorDesc')"
									:label="this.$t('design.btnBackgroundColor')"
									label-for="btnBackground"
								>
									<b-form-input id="btnBackground" class="color-input" type="color" v-model="settings.btnBackground"/>
								</b-form-group>
							</b-col>
							<b-col class="mb-3" lg="6">
								<b-form-group
									:description="this.$t('design.btnForegroundColorDesc')"
									:label="this.$t('design.btnForegroundColor')"
									label-for="btnColor"
								>
									<b-form-input id="btnColor" class="color-input" type="color" v-model="settings.btnColor"/>
								</b-form-group>
							</b-col>
							<b-col class="mb-3" lg="6">
								<b-form-group
									:description="this.$t('design.backgroundColorDesc')"
									:label="this.$t('design.backgroundColor')"
									label-for="background"
								>
									<b-form-input id="background" class="color-input" type="color" v-model="settings.background"/>
								</b-form-group>
							</b-col>
						</b-row>
					</b-col>

					<b-col lg="4">
						<b-card class="mb-4">
							<p class="text-muted mb-1">{{ this.$t('design.example') }}</p>
							<b-card :style="`background:${settings.background}`">
								<b-button :style="`background:${settings.btnBackground};color:${settings.btnColor};border:none`" variant="primary" block>{{ this.$t('design.bookHere') }}</b-button>
							</b-card>
						</b-card>
					</b-col>
				</b-row>
				<!-- /files -->
			</div>
		</div>
	</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import FilesRelated from '@/components/helpers/FilesRelated'

export default {
	components: {
		MainLayout,
		FilesRelated,
	},
	data() {
		let defaultSettings = {
			background: '#E5E3FF',
			btnColor: '#ffffff',
			primaryColor: '#5D59D4',
			btnBackground: '#5D59D4',
			publicName: '',
		}

		return {
			settings:{...defaultSettings},
		}
	},
	computed: {},
	methods: {
		fetchModel(){
			this.loading = true
			this.$root.api.get('setting-vars').then((res) => {
				this.settings = {...res.data.settingVars}
				this.loading = false
			}).catch(this.$root.handleRequestError);
		},
		updateSettings(){
			let settings = {
				publicName: this.settings.publicName,
				primaryColor: this.settings.primaryColor,
				btnBackground: this.settings.btnBackground,
				btnColor: this.settings.btnColor,
				background: this.settings.background,
			}

			this.loading = true

			this.$root.api.put('/setting-vars',{ settings }).then(() => {
				this.$root.showAlert(this.$t('global.updatedConfigurations'))
				this.loading = false
				this.fetchModel()
			}).catch(this.$root.handleRequestError);
		}
	},
	mounted() {
		this.fetchModel()
	}
}
</script>
